import to from 'await-to-js'
import client from '@/api/client'
import npsFeedbackCategoriesQuery from '@/api/gql/_shared/nps/query/nps-feedback-categories.gql'

export default {
  namespaced: true,
  state: {
    npsFeedbackCategories: [],
  },

  mutations: {
    setState(state, payload) {
      for (let key in payload) state[key] = payload[key]
    },
  },

  actions: {
    async fetchData({ commit }) {
      const [error, result] = await to(client.query({ query: npsFeedbackCategoriesQuery }))
      if (error) {
        this.$rollbar.error(error?.message)
      } else {
        commit('setState', result.data)
      }
    },
  },
}
